import {  useState, useEffect } from "react";
import { Button } from "antd";
import { MdLink } from "react-icons/md";
import { deepEqual, returnDayOrDays } from "./utils";

import useModal from "../../../hooks/useModalPlanejamentoOperacoes";
import { 
  CustomModal,
  Header,
  OperationDetail,
  OperationItem,
  OperationList,
  OperationMeta,
  OperationName,
  OperationSeqBadge,
  Title,
  ContainerFooter,
  ButtonRemove
} from "./styles";
import { formatarDataSemTimezone } from "../utils";

interface Props {
  form: any
}

function ModalVinculo({ form }: Props) {
  const {
    isOpenModalVinculo, setIsOpenModalVinculo,
    listPlanoOperacionalTalhao,
    setOperacaoVinculadaItem,
    operacaoVinculadaItem
  } = useModal();
  const [itemSelected, setItemSelected] = useState(operacaoVinculadaItem);
  

  function handleClose(handleSubmit: boolean = false) {
    if (!handleSubmit) {
      if (!operacaoVinculadaItem || !itemSelected) {
        form.setFieldsValue({ referencia: '' });
      }
    }
    setItemSelected(null);
    setIsOpenModalVinculo(false);
  }
 
  useEffect(() => {
      setItemSelected(operacaoVinculadaItem);
  }, [isOpenModalVinculo]);


  function handleRemoveItem() {
    setOperacaoVinculadaItem(null);
    form.setFieldsValue({ referencia: '' });
    setItemSelected(null);
    setIsOpenModalVinculo(false);
  }

  function handleSubmit() {
    if (itemSelected) setOperacaoVinculadaItem(itemSelected);
    handleClose(true);
  }
  const filterAndUnificateRow = () => {
    const rowsFiltered = listPlanoOperacionalTalhao;

    const newRowsFiltered =  Array.from(
        new Map(
          rowsFiltered.map(item => [
            `${item.index}-${item.operacao}-${item.carenciaQuantidadeDias}-${item.dataProgramada}`,
            item,
          ])
        ).values()
      );

    const sorted = [...newRowsFiltered].sort((a: any, b: any) => {
          const da = a?.dataProgramada
            ? new Date(a.dataProgramada).getTime()
            : Infinity

          const db = b?.dataProgramada
            ? new Date(b.dataProgramada).getTime()
            : Infinity

          return da - db
        });

      return sorted;
  }

  return (
    <CustomModal
      title={
        <Header>
          <MdLink  size={28} />
          Selecionar Operação Vinculada
        </Header>
      }
      visible={isOpenModalVinculo}
      width={560}
      onCancel={() => handleClose()}
      maskClosable={false}
      destroyOnClose
      centered
      getContainer={document.body}
      footer={
        <ContainerFooter>
          <div>
            <ButtonRemove
              size="large"
              onClick={handleRemoveItem}
              type="default"
            >Remover Vinculo</ButtonRemove>
          </div>
         <div>
           <Button
              size="large"
              onClick={() => handleClose()}
              style={{ borderRadius: 8 }}
            >Cancelar
            </Button>
          <Button
            size="large"
            type="primary"
            style={{ backgroundColor: "#12619C", borderRadius: 8, display: "flex", alignItems: "center", gap: 8, float: "right" }}
            onClick={handleSubmit}
            >  Confirmar</Button>
         </div>
        </ContainerFooter>
      }
    >

      <Title>
        Selecione a operação à qual esta operação deve estar vinculada.
      </Title>
      <OperationList>
        {
          filterAndUnificateRow()?.map((item: any) => (
            <OperationItem key={item.id}
              onClick={() => {
                if (item?.vinculo) return;
                setItemSelected(item);
              }}
              isSelected={deepEqual(item, itemSelected)} disabled={item?.vinculo}>
              <OperationSeqBadge isSelected={deepEqual(item, itemSelected)}>{item?.index}</OperationSeqBadge>
              <OperationDetail>
                <OperationName>{item.operacao_operacao ?? ' - '}</OperationName>
                <OperationMeta>Carência: {returnDayOrDays(item.carenciaQuantidadeDias ?? 0)} - Data Programada: {formatarDataSemTimezone(item?.dataProgramada) ?? ''}</OperationMeta>
              </OperationDetail>
            </OperationItem>
          ))
        }
      </OperationList>

    </CustomModal>
  );
}

export default ModalVinculo;
